import { render, staticRenderFns } from "./SelfRegistration.vue?vue&type=template&id=3c0e98db&scoped=true"
import script from "./SelfRegistration.vue?vue&type=script&lang=js"
export * from "./SelfRegistration.vue?vue&type=script&lang=js"
import style0 from "./SelfRegistration.vue?vue&type=style&index=0&id=3c0e98db&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0e98db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0e98db')) {
      api.createRecord('3c0e98db', component.options)
    } else {
      api.reload('3c0e98db', component.options)
    }
    module.hot.accept("./SelfRegistration.vue?vue&type=template&id=3c0e98db&scoped=true", function () {
      api.rerender('3c0e98db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Login/SelfRegistration.vue"
export default component.exports